var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseballSoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72,
    cy: 30.9,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3,43.7c-3.6,0-6.4,2.9-6.4,6.4c0,3.6,2.9,6.4,6.4,6.4c3.6,0,6.4-2.9,6.4-6.4C133.7,46.6,130.8,43.7,127.3,43.7z  M127.3,53.9c-2,0-3.7-1.7-3.7-3.7c0-2,1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7C131,52.2,129.3,53.9,127.3,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,73.1c0.9,0.9,2.2,1.5,3.6,1.5c1.4,0,2.7-0.6,3.6-1.5l0,0l11.8-11.8v18.4h20.6v-27c0-2.3-0.9-4.6-2.6-6.4 c-1.8-1.8-4.1-2.6-6.4-2.6H29.6l21.5-16.9L64,13.9l0,0l0,0l0,0l0,0c2-2,2-5.2,0-7.2c-2-2-5.3-2-7.3,0l0,0L43.9,19.5L24.9,43.7h-3.1 c-1.3,0-2.6,0.5-3.6,1.5c-2,2-2,5.3,0,7.3L38.8,73.1z M45.9,21.3L58.5,8.6l0,0c0,0,0,0,0,0l0,0l0,0c1-0.9,2.5-0.9,3.4,0 c0.9,0.9,0.9,2.5,0,3.4l0,0L49.4,24.7L31.5,39.2L45.9,21.3z M50.5,54l-8.2,8.2L34.2,54H50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1,130.1l-17.7-17.7V84.8H57.8L12.6,130c-0.9,0.9-1.5,2.2-1.5,3.6c0,2.8,2.3,5.1,5.1,5.1c1.4,0,2.7-0.6,3.6-1.5 l48.2-48.2v25.4c0,1.3,0.5,2.6,1.5,3.6l19.2,19.2l0,0c2,2,5.3,2,7.3,0C98.1,135.3,98.1,132.1,96.1,130.1 C96.1,130.1,96.1,130.1,96.1,130.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseballSoft);
export default __webpack_public_path__ + "static/media/baseballSoft.e3c8fc6215f6fdb3240684a88b06debc.svg";
export { ForwardRef as ReactComponent };